import React, { useEffect, useRef, useState } from "react";
import { classes } from "../../../core/data/json/classes";
import Table from "../../../core/common/dataTable/index";
import PredefinedDateRanges from "../../../core/common/datePicker";
import {
  activeList,
  classSection,
  classSylabus,
} from "../../../core/common/selectoption/selectoption";
import CommonSelect from "../../../core/common/commonSelect";
import { Link } from "react-router-dom";
import TooltipOption from "../../../core/common/tooltipOption";
import { all_routes } from "../../router/all_routes";
import UserService from "../../network/services/UserService";
import { getUser } from "../../network/auth/Auth";
import { Modal, Toast } from "react-bootstrap";

const Batches = () => {
  const routes = all_routes;

  const data = classes;
  const dropdownMenuRef = useRef<HTMLDivElement | null>(null);
  const handleApplyClick = () => {
    if (dropdownMenuRef.current) {
      dropdownMenuRef.current.classList.remove("show");
    }
  };
  const route = all_routes

  interface CourseData {
    id: any;
    name: any;
    code: any;
    parent_id: any;
    evaluation_type: any;
    subject_ids: any;
    department_id: any;
    active: any;
    fees_term_id: any;
    operating_branch_id: any;
    company_id: any

  }
  interface BatchData {
    id: any;
    name: any;
    code: any;
    start_date: any;
    end_date: any;
    course_id: any;
    active: any;
    operating_branch_id: any;
    company_id: any

  }
  interface Option {
    id: any;
    name: any;
  }



  interface OptionType {
    id: any;
    name: any;
  }


  const [isActionSuccessful, setIsActionSuccessful] = useState(false);
  const [isActionSuccessfulEdit, setIsActionSuccessfulEdit] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showDangerToast, setShowDangerToast] = useState(false);
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState<any>({
    name: '',
    code: '',
    evaluation_type: '',
    subject_ids: [],
    max_unit_load: '',
    min_unit_load: '',
    operating_branch_id: '',
    company_id: ''
  });




  const handleSuccessToastClose = () => {
    setShowSuccessToast(false);
  };

  const handleDangerToastClose = () => {
    setShowDangerToast(false);
  };

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  const handleClose2 = () => setShowModal2(false);
  const handleShow2 = () => setShowModal2(true);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setShowDangerToast(false);
    }, 3000);
    return () => clearTimeout(timeoutId);
  }, [showDangerToast]);


  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setShowSuccessToast(false);
    }, 4000);
    return () => clearTimeout(timeoutId);
  }, [showSuccessToast]);

  const [formData, setFormData] = useState({
    name: '',
    code: '',
    start_date: '',
    end_date: '',
    course_id: '',
    operating_branch_id: '',
    company_id: ''
  });

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleInputChangeEdite = (e: any) => {
    const { name, value } = e.target;
    setSelectedRecord((prevRecord: any) => ({
      ...prevRecord,
      [name]: value
    }));
  };

  const handleInputChangeEdite2 = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const { value } = event.target;
    const selectedBranch = branches.find((branch: any) => branch.id === parseInt(value, 10));

    if (selectedBranch) {
      setSelectedRecord((prevState: any) => ({
        ...prevState,
        operating_branch_id: [selectedBranch],
      }));
    }
  };

  const handleInputChangeEdite3 = (selectedOptions: any) => {
    if (selectedOptions) {
      const selectedSubjects = selectedOptions.map((option: any) => ({
        id: option.value,
        name: option.label,
      }));

      setSelectedRecord((prevState: any) => ({
        ...prevState,
        subject_ids: selectedSubjects,
      }));
    } else {
      setSelectedRecord((prevState: any) => ({
        ...prevState,
        subject_ids: [],
      }));
    }
  };



  const handleSelectChange = (selectedOption: any, actionMeta: any) => {

    setFormData({
      ...formData,
      [actionMeta.name]: selectedOption
    });
  };


  const [multiSubject, setMultiSubject] = useState<OptionType[]>([]);

  const handleEdit = (record: any) => {
    setSelectedRecord(record)
    handleShow2()
    console.log(record)

  };




  const handleSubmit = () => {
    setIsLoading(true)

    const request_data = {
      name: formData.name,
      code: formData.code,
      start_date: formData.start_date,
      end_date: formData.end_date,
      course_id: parseInt(formData.course_id, 10),
      company_id: getUser()?.company_ids[0]?.id,
      operating_branch_id: formData.operating_branch_id === "" ? getUser()?.company_ids[0]?.branches[0]?.id : parseInt(formData.operating_branch_id, 10),
    };

    UserService.addBatch(request_data, (response: any) => {
      if (response.data && response.success) {
        fetchData(getUser()?.company_ids[0]?.branches[0]?.id, getUser()?.company_ids[0]?.id, branch);
        setIsLoading(false)
        setIsActionSuccessful(true)
        setSuccessMessage('Data saved successfully')
        setShowSuccessToast(true)


        setShowModal(false);

      } else {
        setErrorMessage('An error has occurred, please try again.')
        setShowDangerToast(true)
        setIsLoading(false)
      }
    });
  };

  const handleSubmitEdit = () => {


    setIsLoading(true)
    const request_data = {
      name: selectedRecord.name,
      code: selectedRecord.code,
      start_date: selectedRecord.start_date,
      end_date: selectedRecord.end_date,
      course_id: Array.isArray(selectedRecord.course_id) ? parseInt(selectedRecord.course_id[0].id, 10) : parseInt(selectedRecord.course_id, 10),
      company_id: getUser()?.company_ids[0]?.id,
      operating_branch_id: selectedRecord?.operating_branch_id?.[0]?.id === undefined ? parseInt(selectedRecord?.operating_branch_id?.[0]?.id, 10) : parseInt(selectedRecord?.operating_branch_id?.[0]?.id, 10),
    };
    console.log(request_data)
    console.log(selectedRecord)


    UserService.editBatch(selectedRecord?.id, request_data, (response: any) => {
      if (response.data && response.success) {
        fetchData(getUser()?.company_ids[0]?.branches[0]?.id, getUser()?.company_ids[0]?.id, branch);
        setIsLoading(false)
        setIsActionSuccessfulEdit(true)

        setFormData({
          name: '',
          code: '',
          start_date: '',
          end_date: '',
          course_id: '',
          operating_branch_id: '',
          company_id: ''
        });
        handleClose2()
      } else {

        setErrorMessage('An error has occurred, please try again.')
        setShowDangerToast(true)
        setIsLoading(false)
      }
    });
  };

  const formatDate = (date: Date | string) => {
    if (!date) return '';

    const d = new Date(date);
    const month = `${d.getMonth() + 1}`.padStart(2, '0');
    const day = `${d.getDate()}`.padStart(2, '0');
    const year = d.getFullYear();

    return `${year}-${month}-${day}`;
  };










  const [batches, setBatches] = useState<BatchData[]>([]);
  const [branch, setBranch] = useState<any>();
  const branches = getUser()?.company_ids[0]?.branches;




  const fetchData = async (branch_id: any, company_id: any, item: any) => {
    if (item) {
      setBranch(item.name);
    }
    UserService.getBatchesByBranchAndComapny(branch_id, company_id, (response: any) => {
      if (response?.data && response?.success) {
        setBatches(response.data);
      } else {
        setBatches([])
      }
    });
  };

  const fetchDataInit = async (company_id: any) => {
    setBranch('All');
    UserService.getBatchesByBranchAndComapnyAll(company_id, (response: any) => {
      if (response?.data && response?.success) {
        setBatches(response.data);

      } else {
        setBatches([]);
      }
    });
  };

  useEffect(() => {
    fetchDataInit(getUser()?.company_ids[0]?.id);

  }, []);



  const [courses, setCourses] = useState<CourseData[]>([]);

  const fetchDataCourse = async (company_id: any) => {
    UserService.getCourseByBranchAndComapny2(company_id, (response: any) => {
      if (response?.data && response?.success) {
        setCourses(response.data);
      }
    });
  };


  useEffect(() => {
    fetchDataCourse(getUser()?.company_ids[0]?.id);
  }, []);


  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      render: (text: string, record: any, index: number) => (
        <>
          <Link to="#" className="link-primary">
            {record.id}
          </Link>
        </>
      ),
    },

    {
      title: "Name",
      dataIndex: "name",
      sorter: (a: BatchData, b: BatchData) => a.name.length - b.name.length,
    },
    {
      title: "Code",
      dataIndex: "code",
      sorter: (a: BatchData, b: BatchData) =>
        a.code.length - b.code.length,
    },
    {
      title: "Start date",
      dataIndex: "start_date",
      sorter: (a: BatchData, b: BatchData) =>
        a.start_date.length - b.start_date.length,
    },
    {
      title: "End date",
      dataIndex: "end_date",
      sorter: (a: BatchData, b: BatchData) =>
        a.end_date.length - b.end_date.length,
    },

    {
      title: "Branhe",
      dataIndex: "operating_branch_id",
      render: (record: any) => (
        <>
          {record && record?.map((item: any, index: any) => (
            <span className="">

              {item.name}
            </span>
          ))}

        </>
      ),
      sorter: (a: BatchData, b: BatchData) =>
        a.operating_branch_id.length - b.operating_branch_id.length,
    },
    {
      title: "Company",
      dataIndex: "company_id",
      render: (record: any) => (
        <>
          {record && record?.map((item: any, inex: any) => (
            <span className="">

              {item.name}
            </span>
          ))}

        </>
      ),
      sorter: (a: BatchData, b: BatchData) =>
        a.company_id.length - b.company_id.length,
    },
    {
      title: "Status",
      dataIndex: "active",
      render: (record: any) => (
        <>
          {record ? (
            <span className="badge badge-soft-success d-inline-flex align-items-center">
              <i className="ti ti-circle-filled fs-5 me-1"></i>
              Active
            </span>
          ) : (
            <span className="badge badge-soft-danger d-inline-flex align-items-center">
              <i className="ti ti-circle-filled fs-5 me-1"></i>
              Inactive
            </span>
          )}
        </>
      ),
    },
    {
      title: "Action",

      render: (record: any) => (
        <>
          <div className="d-flex align-items-center">
            <div className="dropdown">
              <Link
                to="#"
                className="btn btn-white btn-icon btn-sm d-flex align-items-center justify-content-center rounded-circle p-0"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="ti ti-dots-vertical fs-14" />
              </Link>
              <ul className="dropdown-menu dropdown-menu-right p-3">
                <li>
                  <Link
                    className="dropdown-item rounded-1"
                    to="#"
                    onClick={() => handleEdit(record)}
                  >
                    <i className="ti ti-edit-circle me-2" />
                    Edit
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item rounded-1"
                    to="#"
                    data-bs-toggle="modal"
                    data-bs-target="#delete-modal"
                  >
                    <i className="ti ti-trash-x me-2" />
                    Delete
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </>
      ),
    },
  ];
  return (
    <div>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Batches List</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={route.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="#">Batches </Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    All Batches
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <TooltipOption />
              {getUser().role === "school_admin" && (<div className="mb-2">
                <Link to="#" className="btn btn-primary d-flex align-items-center" onClick={handleShow}>
                  <i className="ti ti-square-rounded-plus me-2" />
                  Add Batches
                </Link>

              </div>)}

            </div>
          </div>
          {/* /Page Header */}
          {/* Guardians List */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="mb-3">Batches List</h4>
              <div className="d-flex align-items-center flex-wrap">
                <div className="input-icon-start mb-3 me-2 position-relative">
                  <PredefinedDateRanges />
                </div>
                <div className="dropdown mb-3 me-2">
                  <Link
                    to="#"
                    className="btn btn-outline-light bg-white dropdown-toggle"
                    data-bs-toggle="dropdown"
                    data-bs-auto-close="outside"
                  >
                    <i className="ti ti-filter me-2" />
                    Filter
                  </Link>
                  <div className="dropdown-menu drop-width" ref={dropdownMenuRef}>
                    <form >
                      <div className="d-flex align-items-center border-bottom p-3">
                        <h4>Filter</h4>
                      </div>
                      <div className="p-3 border-bottom pb-0">
                        <div className="row">
                          <div className="col-md-12">
                            <div className="mb-3">
                              <label className="form-label">Class</label>
                              <CommonSelect
                                className="select"
                                options={classSylabus}
                                defaultValue={classSylabus[0]}
                              />
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="mb-3">
                              <label className="form-label">Section</label>
                              <CommonSelect
                                className="select"
                                options={classSection}
                                defaultValue={classSection[0]}
                              />
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="mb-3">
                              <label className="form-label">Status</label>
                              <CommonSelect
                                className="select"
                                options={activeList}
                                defaultValue={activeList[0]}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="p-3 d-flex align-items-center justify-content-end">
                        <Link to="#" className="btn btn-light me-3">
                          Reset
                        </Link>
                        <Link
                          to="#"
                          className="btn btn-primary"
                          onClick={handleApplyClick}
                        >
                          Apply
                        </Link>
                      </div>
                    </form>
                  </div>
                </div>
                <div className="dropdown mb-3">
                  <Link to="#" className="btn btn-outline-light bg-white dropdown-toggle" data-bs-toggle="dropdown">
                    <i className="ti ti-sort-ascending-2 me-2" />
                    {branch}
                  </Link>
                  <ul className="dropdown-menu p-3">
                    <li >
                      <a className="dropdown-item rounded-1" onClick={() => fetchDataInit(getUser()?.company_ids[0]?.id)}>
                        All
                      </a>
                    </li>
                    {branches?.map((item: any) => (
                      <li key={item.id}>
                        <a className="dropdown-item rounded-1" onClick={() => fetchData(item.id, getUser()?.company_ids[0]?.id, item)}>
                          {item.name}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
            <div className="card-body p-0 py-3">
              {/* Guardians List */}
              <Table columns={columns} dataSource={batches} Selection={true} />
              {/* /Guardians List */}
            </div>
          </div>
          {/* /Guardians List */}
        </div>
      </div>
      ;{/* /Page Wrapper */}
      <>
        {/* Add Classes */}
        <div className="modal fade" id="add_class">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Add Class</h4>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <form>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label">Class Name</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Section</label>
                        <CommonSelect
                          className="select"
                          options={classSection}
                          defaultValue={classSection[0]}
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">No of Students</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">No of Subjects</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="d-flex align-items-center justify-content-between">
                        <div className="status-title">
                          <h5>Status</h5>
                          <p>Change the Status by toggle </p>
                        </div>
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id="switch-sm"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <Link
                    to="#"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <Link to="#" className="btn btn-primary" data-bs-dismiss="modal">
                    Add Class
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /Add Classes */}
        {/* Edit Classes */}
        <div className="modal fade" id="edit_class">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Edit Class</h4>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <form >
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label">Class Name</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Class Name"
                          defaultValue="I"
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Section</label>
                        <CommonSelect
                          className="select"
                          options={classSection}
                          defaultValue={classSection[0]}
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">No of Students</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter no of Students"
                          defaultValue={30}
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">No of Subjects</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter no of Subjects"
                        // defaultValue={03}
                        />
                      </div>
                      <div className="d-flex align-items-center justify-content-between">
                        <div className="status-title">
                          <h5>Status</h5>
                          <p>Change the Status by toggle </p>
                        </div>
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id="switch-sm2"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <Link
                    to="#"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <Link to="#" className="btn btn-primary" data-bs-dismiss="modal">
                    Save Changes
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /Edit Classes */}
        {/* Delete Modal */}
        <div className="modal fade" id="delete-modal">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <form >
                <div className="modal-body text-center">
                  <span className="delete-icon">
                    <i className="ti ti-trash-x" />
                  </span>
                  <h4>Confirm Deletion</h4>
                  <p>
                    You want to delete all the marked items, this cant be undone
                    once you delete.
                  </p>
                  <div className="d-flex justify-content-center">
                    <Link
                      to="#"
                      className="btn btn-light me-3"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </Link>
                    <Link to="#" className="btn btn-danger" data-bs-dismiss="modal"
                    >
                      Yes, Delete
                    </Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /Delete Modal */}
        {/* View Classes */}
        <div className="modal fade" id="view_class">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <div className="d-flex align-items-center">
                  <h4 className="modal-title">Class Details</h4>
                  <span className="badge badge-soft-success ms-2">
                    <i className="ti ti-circle-filled me-1 fs-5" />
                    Active
                  </span>
                </div>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <form >
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="class-detail-info">
                        <p>Class Name</p>
                        <span>III</span>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="class-detail-info">
                        <p>Section</p>
                        <span>A</span>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="class-detail-info">
                        <p>No of Subjects</p>
                        <span>05</span>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="class-detail-info">
                        <p>No of Students</p>
                        <span>25</span>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /View Classes */}



        <Modal show={showModal} onHide={handleClose} >
          <Modal.Header >
            <Modal.Title>Add Batch</Modal.Title>
            <button
              type="button"
              className="btn-close custom-btn-close"
              onClick={handleClose}

            >
              <i className="ti ti-x" />
            </button>
          </Modal.Header>
          <Modal.Body>
            <form>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">Name</label>
                      <input type="text" className="form-control" placeholder="Name" name="name" value={formData.name}
                        onChange={handleInputChange} />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Code</label>
                      <input type="text" className="form-control" name="code" placeholder="Code" value={formData.code}
                        onChange={handleInputChange} />

                    </div>
                    <div className="mb-3">
                      <label className="form-label">Start data</label>
                      <input type="date" className="form-control" name="start_date"
                        value={formData.start_date}
                        onChange={handleInputChange} />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">End date</label>
                      <input type="date" className="form-control" name="end_date"
                        value={formData.end_date}
                        onChange={handleInputChange} />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">	Course</label>
                      <select

                        className="select react-select form-control"
                        name="course_id"
                        onChange={handleInputChange}
                      >
                        <option >Select Course</option>
                        {courses && courses?.map((item: any) => (
                          <option key={item.id} value={item.id}>{item.name}</option>
                        ))}

                      </select>
                    </div>



                    <div className="mb-3">
                      <label className="form-label">Branch</label>
                      <select

                        className="select react-select form-control"
                        name="operating_branch_id"
                        onChange={handleInputChange}
                      >
                        <option >Select Branch</option>
                        {branches && branches?.map((item: any) => (
                          <option key={item.id} value={item.id}>{item.name}</option>
                        ))}

                      </select>
                    </div>


                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <span
                  className="btn btn-light me-2"
                  onClick={handleClose}
                >
                  Cancel
                </span>
                <a className="btn btn-primary" onClick={handleSubmit}  >
                  {isLoading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm align-middle me-1"
                        role="status"
                        aria-hidden="true"
                      />
                      Loading...
                    </>
                  ) : "Add Batch"}

                </a>
              </div>
            </form>
          </Modal.Body>

        </Modal>

        <Modal show={showModal2} onHide={handleClose2} >
          <Modal.Header >
            <Modal.Title>Edit Batch</Modal.Title>
            <button
              type="button"
              className="btn-close custom-btn-close"
              onClick={handleClose2}

            >
              <i className="ti ti-x" />
            </button>
          </Modal.Header>
          <Modal.Body>
            <form>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">Name</label>
                      <input type="text" className="form-control" placeholder="Name" name="name" value={selectedRecord?.name}
                        onChange={handleInputChangeEdite} />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Code</label>
                      <input type="text" className="form-control" name="code" value={selectedRecord.code}
                        onChange={handleInputChangeEdite} />

                    </div>
                    <div className="mb-3">
                      <label className="form-label">Start data</label>
                      <input type="date" className="form-control" name="start_date"
                        value={formatDate(selectedRecord?.start_date)}
                        onChange={handleInputChangeEdite} />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">End date</label>
                      <input type="date" className="form-control" name="end_date"
                        value={formatDate(selectedRecord?.end_date)}
                        onChange={handleInputChangeEdite} />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">	Course</label>
                      <select

                        className="select react-select form-control"
                        name="course_id"
                        value={selectedRecord.course_id?.[0]?.id}
                        onChange={handleInputChangeEdite}
                      >
                        <option >Select Course</option>
                        {courses && courses?.map((item: any) => (
                          <option key={item.id} value={item.id}>{item.name}</option>
                        ))}

                      </select>
                    </div>


                    <div className="mb-3">
                      <label className="form-label">Branch</label>
                      <select
                        className="select react-select form-control"
                        name="operating_branch_id"
                        value={selectedRecord?.operating_branch_id?.[0]?.id || ''}// Assurez-vous que cette valeur correspond à une option
                        onChange={handleInputChangeEdite2}
                      >
                        {branches && branches.map((item: any) => (
                          <option value={item.id}>
                            {item.name}
                          </option>
                        ))}
                      </select>

                    </div>


                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <span
                  className="btn btn-light me-2"
                  onClick={handleClose2}
                >
                  Cancel
                </span>
                <Link to="#" className="btn btn-primary" onClick={handleSubmitEdit}  >
                  {isLoading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm align-middle me-1"
                        role="status"
                        aria-hidden="true"
                      />
                      Loading...
                    </>
                  ) : "Edit Batch"}

                </Link>
              </div>
            </form>
          </Modal.Body>

        </Modal>

        <Toast
          show={showDangerToast}
          onClose={handleDangerToastClose}
          id="dangerToast"
          className="toast-container position-fixed top-0 end-0 p-3 colored-toast bg-danger-transparent"
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
          style={{ minWidth: "200px!important" }}
        >
          <Toast.Header closeButton className="bg-danger text-fixed-white">
            <strong className="me-auto">Message</strong>
            <span
              className="cursor-pointer"
              onClick={handleDangerToastClose}
              aria-label="Close"
              style={{ cursor: "pointer" }}
            />
          </Toast.Header>
          <Toast.Body>
            {/* Add your toast content here */}
            {errorMessage}
          </Toast.Body>
        </Toast>

        <Toast
          show={showSuccessToast}
          onClose={handleSuccessToastClose}
          id="successToast"
          className="toast-container position-fixed top-0 end-0 p-3  colored-toast bg-success-transparent"
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
        >

          <Toast.Body>
            {/* Add your toast content here */}
            {successMessage}
          </Toast.Body>
        </Toast>
      </>
    </div>
  );
};

export default Batches;
